// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"IppicaHeaderNumeroCorsa_paragraph__eSH09","span":"IppicaHeaderNumeroCorsa_span__Ifv6o","small":"IppicaHeaderNumeroCorsa_small__ZvOpP"};